import { render, staticRenderFns } from "./subjectWiseProbableConfirmedCandidateList.vue?vue&type=template&id=b6cf7ed4&scoped=true&"
import script from "./subjectWiseProbableConfirmedCandidateList.vue?vue&type=script&lang=js&"
export * from "./subjectWiseProbableConfirmedCandidateList.vue?vue&type=script&lang=js&"
import style0 from "./subjectWiseProbableConfirmedCandidateList.vue?vue&type=style&index=0&id=b6cf7ed4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cf7ed4",
  null
  
)

export default component.exports